export const countnovel = {
    lang: 'en',
    company: 'countnovel.com',
    name: 'Countnovel',
    email: 'jannatjahan36487@gmail.com',
    fbPixel: {
        1: '1438847163760449',
    },
    adx: {
        1: '/29746187,23215273386/HK_CN_keepreadingbook.com_banner_t2',
    },
    ga4: {
        id: 'G-JR9JHZ3DYK'
    },
    adConfig: {
        default: {
            // 关闭遮罩时间
            closeMaskTime: 20000,
            // 倒计时时间
            time: 40000,
            // 20s 计数
            interTime: 20,
            // 是否可以点击穿透
            // 点击广告上线
            clickMax: 3,
        }
    },
    content:{
        1: {
            split: '\n\n',
            textNum: 2000,
            p: 10,
        },
    },
    pixelReport: {
        default: {
            chapter: new Set([1, 3, 5, 10, 20, 30]),
            rate: 0.6
        }
    }
}